// @ts-nocheck
// @ts-ignore
import Pagination from '../Shared/Pagination/Pagination';
import NoData from '../NoData/NoData';
import { useState, useMemo, useRef, useEffect } from 'react';
// import { FaSortUp, FaSortDown } from 'react-icons/fa';
import { FaSortUp, FaSortDown, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';

const NtxTable = ({
  data,
  columns,
  dataPerPage = 10,
  tableClass = '',
  theadClass = '',
  enableSearch = false, //  ظهور ابحث او لا
  showRecordsSelector = false, //  ظهور خيار عدد السجلات المعروضة
  messageEmpty = '',
  renderRow = null, // ✅ هنا أضفنا البروبس الجديد
  searchColumns = [] // أسماء الأعمدة التي سيتم البحث فيها
}) => {
  const { t } = useTranslation();
  // إدارة الحالة للبحث
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');
  const [recordsPerPage, setRecordsPerPage] = useState(dataPerPage); // حالة لإدارة عدد السجلات المعروضة

  const tableContainerRef = useRef(null);
  const [showScrollIcons, setShowScrollIcons] = useState(false);

  const [showLeftIcon, setShowLeftIcon] = useState(false);
  const [showRightIcon, setShowRightIcon] = useState(false);
  // const [isRTL, setIsRTL] = useState(localStorage.i18nextLng=== 'ar' || true);

  const isRTL = document.documentElement.dir === 'rtl' || localStorage.i18nextLng === 'ar';

  useEffect(() => {
    const checkScrollable = () => {
      if (tableContainerRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = tableContainerRef.current;

        const adjustedScrollLeft = isRTL ? Math.abs(scrollLeft) : scrollLeft; // التعامل مع RTL

        setShowScrollIcons(scrollWidth > clientWidth); // هل يوجد تمرير؟

        // في RTL: إظهار أيقونة اليسار إذا لم يكن في النهاية
        setShowLeftIcon(isRTL ? adjustedScrollLeft < scrollWidth - clientWidth - 2 : scrollLeft > 0);

        // في RTL: إظهار أيقونة اليمين إذا لم يكن في البداية
        // setShowRightIcon(isRTL ? Math.floor(adjustedScrollLeft) > 0 : scrollLeft < scrollWidth - clientWidth);
        setShowRightIcon(isRTL ? Math.floor(adjustedScrollLeft) > 0 : scrollLeft < scrollWidth - clientWidth - 1);
      }
    };

    checkScrollable();
    window.addEventListener('resize', checkScrollable);
    // @ts-ignore
    tableContainerRef.current?.addEventListener('scroll', checkScrollable);

    return () => {
      window.removeEventListener('resize', checkScrollable);
      // @ts-ignore
      tableContainerRef.current?.removeEventListener('scroll', checkScrollable);
    };
  }, [data, columns, isRTL]);

  // دالة تحريك الجدول عند تمرير الماوس فوق الأيقونات
  // @ts-ignore
  const scrollTable = direction => {
    if (tableContainerRef.current) {
      // @ts-ignore
      tableContainerRef.current.scrollBy({
        left: direction === 'left' ? -400 : 400,
        behavior: 'smooth'
      });
    }
  };

  // const filteredData = useMemo(() => {
  //   if (!enableSearch || !searchQuery) return data;

  //   return data?.filter(row => {
  //     // إذا لم يتم تحديد أعمدة بحث، نبحث في جميع الأعمدة
  //     const columnsToSearch = searchColumns || columns.map(col => col.key);

  //     return columnsToSearch.some(columnKey => {
  //       const cellValue = row[columnKey] || '';
  //       return cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
  //     });
  //   });
  // }, [data, searchQuery, columns, enableSearch, searchColumns]);

  const filteredData = useMemo(() => {
    if (!enableSearch || !searchQuery) return data;

    return data?.filter(row => {
      // تحديد الأعمدة التي سيتم البحث فيها
      // إذا لم يتم تحديد أعمدة بحث (searchColumns فارغ أو غير محدد)، نستخدم جميع أعمدة الجدول
      const columnsToSearch = searchColumns && searchColumns.length > 0 ? searchColumns : columns.map(col => col.key);

      return columnsToSearch.some(columnKey => {
        const cellValue = row[columnKey] || '';
        return cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, columns, enableSearch, searchColumns]);

  // فرز البيانات
  // const sortedData = useMemo(() => {
  //   if (!sortConfig.key) return filteredData;
  //   return [...filteredData].sort((a, b) => {
  //     // @ts-ignore
  //     if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
  //     // @ts-ignore
  //     if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
  //     return 0;
  //   });
  // }, [filteredData, sortConfig]);

  // فرز البيانات
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;

    const column = columns.find(col => col.key === sortConfig.key);

    return [...filteredData].sort((a, b) => {
      let valueA, valueB;

      // إذا كان العمود يحتوي على دالة sortValue، استخدمها
      if (column?.sortValue) {
        valueA = column.sortValue(a);
        valueB = column.sortValue(b);
      } else {
        // وإلا استخدم القيمة العادية
        valueA = a[sortConfig.key];
        valueB = b[sortConfig.key];
      }

      if (valueA < valueB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortConfig, columns]);

  // حساب الفهرس لبداية ونهاية البيانات
  const indexOfLastData = currentPage * recordsPerPage;
  const indexOfFirstData = indexOfLastData - recordsPerPage;
  const currentData = useMemo(
    () => sortedData?.slice(indexOfFirstData, indexOfLastData),
    [sortedData, indexOfFirstData, indexOfLastData]
  );

  // // دالة التعامل مع الترتيب
  // // @ts-ignore
  // const handleSort = (columnKey, sortable = true) => {
  //   if (!sortable) return;
  //   setSortConfig(prevConfig => ({
  //     key: columnKey,
  //     direction: prevConfig.key === columnKey && prevConfig.direction === 'asc' ? 'desc' : 'asc'
  //   }));
  // };

  // دالة التعامل مع الترتيب
  // @ts-ignore
  const handleSort = (column, sortable = true) => {
    if (!sortable) return;
    setSortConfig(prevConfig => ({
      key: column.key,
      direction: prevConfig.key === column.key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  return (
    <>
      <div className='position-relative'>
        {/* أيقونات التمرير */}

        {showScrollIcons && (
          <div hidden={!showLeftIcon} className='scroll-icon left' onMouseEnter={() => scrollTable('left')}>
            <FaChevronLeft className='text-theme fw-bold' />
          </div>
        )}

        {showScrollIcons && (
          <div hidden={!showRightIcon} className='scroll-icon right' onMouseEnter={() => scrollTable('right')}>
            <FaChevronRight className='text-theme fw-bold' />
          </div>
        )}

        {(showRecordsSelector || enableSearch) && (
          <div className='d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3'>
            {showRecordsSelector && (
              <div className='flex-grow-1' style={{ minWidth: '200px', maxWidth: '250px' }}>
                <div className='input-group'>
                  <span className='input-group-text fw-bold'>{t('Display')}</span>
                  <select
                    className='form-select text-center'
                    value={recordsPerPage}
                    onChange={e => {
                      setRecordsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    {[10, 20, 30, 40].map(num => (
                      <option key={num} className='text-dark' value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {enableSearch && (
              <div className='flex-grow-1' style={{ minWidth: '250px', maxWidth: '400px' }}>
                <div className='input-group'>
                  <span className='input-group-text fw-bold'>
                    <i className='fa fa-search text-theme me-2'></i>
                    {t('Search')}
                  </span>
                  <input
                    type='search'
                    autoComplete='off'
                    className='form-control'
                    placeholder={t('SearchPlaceholder')}
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {/* جدول البيانات */}
        <div className='table-responsive mb-3' ref={tableContainerRef}>
          <table className={tableClass || ' table table-hover'}>
            <thead className={theadClass || 'bg-theme bg-opacity-30'}>
              <tr>
                {/* {columns?.map(
                   column => (
                    <th
                      key={column.key}
                      onClick={() => handleSort(column.key, column.sortable)}
                      style={{
                        cursor: column.sortable === false ? 'default' : 'pointer',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {column.title}
                      <span style={{ display: 'inline-block', width: '1em' }}>
                        {sortConfig.key === column.key &&
                          column.sortable !== false &&
                          (sortConfig.direction === 'asc' ? (
                            <FaSortUp className='text-theme ms-2' />
                          ) : (
                            <FaSortDown className='text-theme ms-2' />
                          ))}
                      </span>
                    </th>
                  )
                )} */}
                {columns?.map(column => (
                  <th
                    key={column.key}
                    onClick={() => handleSort(column, column.sortable)}
                    style={{
                      cursor: column.sortable === false ? 'default' : 'pointer',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {column.title}
                    <span style={{ display: 'inline-block', width: '1em' }}>
                      {sortConfig.key === column.key &&
                        column.sortable !== false &&
                        (sortConfig.direction === 'asc' ? (
                          <FaSortUp className='text-theme ms-2' />
                        ) : (
                          <FaSortDown className='text-theme ms-2' />
                        ))}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td colSpan={columns?.length} className='text-center'>
                    <NoData message={messageEmpty} />
                  </td>
                </tr>
              ) : (
                // @ts-ignore
                currentData?.map((row, rowIndex) => {
                  return typeof renderRow === 'function' ? (
                    // @ts-ignore
                    renderRow(row, rowIndex) // ✅ إذا تم تمرير دالة renderRow
                  ) : (
                    <tr key={rowIndex} className={row.rowClass}>
                      {columns?.map(
                        // @ts-ignore
                        column => (
                          <td key={column.key} className={'align-middle ' + (column.className || '')}>
                            {row[column.key]}
                          </td>
                        )
                      )}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        {data?.length !== 0 && (
          <Pagination
            filteredData={sortedData}
            dataPerPage={recordsPerPage}
            handlePagination={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>

      <style>
        {`
   .scroll-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(var(--bs-theme-rgb), 0.2 );
  // background: rgba(0, 0, 0, 0.3);
  color: white;
  width: 40px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
 border-radius: 50px 0 0 50px; /* نصف دائرة على اليمين */
  cursor: pointer;
  transition: background 0.3s, opacity 0.3s;
  opacity: 0.6;
  z-index: 10;
}

.scroll-icon.left {
  left: 0;
  
   border-radius: 0 50px 50px 0; /* نصف دائرة على اليسار */
}

.scroll-icon.right {
  right: 0;
}

.scroll-icon:hover {
  background: rgba(var(--bs-theme-rgb), 0.3 ) ;
  opacity: 1;
}


    `}
      </style>
    </>
  );
};

export default NtxTable;
